import React from 'react';
import { ThemedText, ThemedView} from "@app/theme";
import { addCommasToNumber } from '@app/utils';
import InfoIcon from '../../../../../assets/Icons/InfoIcon';
import WarnIcon from '@app/assets/svg/WarnIcon';


interface EnhanceLimitCardProps {
  creditLimit: number
}
export const EnhanceLimitCard: React.FC<EnhanceLimitCardProps> = ({ creditLimit }) => (
    <ThemedView flexDirection={"row"} width={"100%"} paddingVertical={"sm"} paddingHorizontal={"md"} backgroundColor={"bg-surface-secondary"} alignItems={"center"} borderRadius={"xs"} mb={"lg"} borderWidth={1} borderColor={"border-secondary"}>
      <WarnIcon />
      <ThemedText variant={"b4m"} color={"text-secondary"} ml={"sm"}>
        {`You have an existing credit limit of`}
      </ThemedText>
      <ThemedText variant={"b4m"} color={"text-secondary"} ml={"sm"} style={{ fontWeight: 'bold' }}>{`₹${addCommasToNumber(creditLimit)}`}</ThemedText>
    </ThemedView>
)